export default "/images/search.svg?efc51868f52b32b0789e8ebfa353c7dd";